export const openLinkInNewTab = (url) => {
  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  document.body.appendChild(link); // Append to body to ensure it works on iOS
  link.click();
  document.body.removeChild(link); // Remove the link after the click
};

export const isSafari = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};
